import { MenuItemId, PageContent } from '@works-web/settings/modules/page';
import { useToast } from '@works-web/settings/modules/toast';
import { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import {
  Tooltip,
  Toggle,
  TimeSetting,
  Dialog,
  DialogButton,
} from '~/settings/__modules__/component';
import {
  SetNotiTimeBiz,
  DEFAULT_TIME,
  TIME_ZONE,
} from '~/settings/biz/SetNotiTimeBiz';

const AREA_OF_SHOW_HOLIDAY = [
  'Asia/Seoul',
  'Asia/Tokyo',
  'Asia/Shanghai',
  'Asia/Urumqi',
  'Asia/Harbin',
  'Asia/Kashgar',
  'Asia/Chongqing',
];

const ifShowHoliday = AREA_OF_SHOW_HOLIDAY.includes(TIME_ZONE);

export default function SubScene() {
  const { t } = useTranslation();
  const toast = useToast();

  const WEEK_DAYS_DES = {
    '0123456': t('noti_alert_daily'),
    12345: t('noti_alert_weekdays'),
    '06': t('noti_alert_weekend'),
    0: t('noti_sun'),
    1: t('noti_mon'),
    2: t('noti_tue'),
    3: t('noti_wen'),
    4: t('noti_thu'),
    5: t('noti_fri'),
    6: t('noti_sat'),
  };

  const [config, setConfig] = useState(null);
  const [alertMsg, setAlertMsg] = useState(null);
  const [curTimeOption, setCurTimeOption] = useState(null);
  const [timezoneOffset] = useState(SetNotiTimeBiz.getGMTOffset());

  const createDaysText = (days) => {
    const weekdays = [...days];
    const weekdaysStr = weekdays.join('');
    if (WEEK_DAYS_DES[weekdaysStr]) {
      return WEEK_DAYS_DES[weekdaysStr];
    } else {
      if (weekdays.length > 1 && weekdays[0] === 0) {
        // Sun sholud be shown at the end
        weekdays.push(weekdays.splice(0, 1)[0]);
      }
      let strArr = [];
      for (let i = 0, len = weekdays.length; i < len; i++) {
        strArr[i] = WEEK_DAYS_DES[weekdays[i]];
      }

      return strArr.join(', ');
    }
  };

  const handleEnableChange = (key, value) => {
    const param = { ...config, [key]: value };
    SetNotiTimeBiz.save(param)
      .then((success) => {
        if (success) {
          setConfig(param);
          toast(t('saved'));
        } else {
          // toast('保存失败');
        }
      })
      .catch(() => {
        setAlertMsg({
          title: <Trans i18nKey="error_unknown_title" />,
          description: <Trans i18nKey="error_unknown_description" />,
        });
      });
  };

  const handleTimeChange = (timeOption) => {
    let timeSettings = [...config.timeSettings];
    for (let i = 0, len = timeSettings.length; i < len; i++) {
      const timeItem = timeSettings[i];
      if (
        timeItem.startTime === timeOption.startTime &&
        timeItem.endTime === timeOption.endTime &&
        timeItem.weekdays.join('') === timeOption.weekdays.join('')
      ) {
        setAlertMsg({
          title: t('noti_alert_pop1'),
        });
        return;
      }
    }
    setCurTimeOption(null);

    let index = timeSettings.findIndex((item) => item.uuid === timeOption.uuid);
    if (index > -1) {
      // 编辑
      timeSettings[index] = timeOption;
    } else {
      // 新增
      timeOption.uuid = SetNotiTimeBiz.uuid();
      timeSettings.push(timeOption);
    }

    const param = {
      ...config,
      timeSettings,
    };
    SetNotiTimeBiz.save(param)
      .then((success) => {
        if (success) {
          setConfig(param);
          toast(t('saved'));
        } else {
          // toast('保存失败');
        }
      })
      .catch(() => {
        setAlertMsg({
          title: <Trans i18nKey="error_unknown_title" />,
          description: <Trans i18nKey="error_unknown_description" />,
        });
      });
  };

  const editTime = (timeOption) => {
    setCurTimeOption(timeOption);
  };

  const deleteTime = (timeOption) => {
    let timeSettings = [...config.timeSettings];
    if (timeSettings.length === 1) {
      setAlertMsg({
        title: t('noti_alert_pop2'),
      });
      return;
    }
    let index = timeSettings.findIndex((item) => item.uuid === timeOption.uuid);
    timeSettings.splice(index, 1);
    const param = {
      ...config,
      timeSettings,
    };
    SetNotiTimeBiz.save(param)
      .then((success) => {
        if (success) {
          setConfig(param);
          toast(t('saved'));
        } else {
          // toast('保存失败');
        }
      })
      .catch(() => {
        setAlertMsg({
          title: <Trans i18nKey="error_unknown_title" />,
          description: <Trans i18nKey="error_unknown_description" />,
        });
      });
  };

  useEffect(() => {
    SetNotiTimeBiz.init().then((result) => {
      setConfig(result);
    });
  }, []);

  return (
    <PageContent
      title={t('noti_alert_setting')}
      parentURL="/settings"
      menuItemId={MenuItemId.NOTIFY}
    >
      {config && (
        <ul className="detail_settings_list notify_detail">
          <li className="item">
            <h4 className="title">
              <span className="text">{t('noti_alert_settingyn')}</span>
            </h4>
            <div className="option_area">
              <Toggle
                value={config.enable}
                label={'Toggle use of auto-reply to external messages'}
                onChange={() => handleEnableChange('enable', !config.enable)}
              />
            </div>
          </li>
          <li className="item auto_reply">
            {config.enable && (
              <>
                <h4 className="title">
                  <span className="text">{t('noti_alert_time')}</span>
                  <span className="timezone">{timezoneOffset}</span>
                </h4>
                <button
                  type="button"
                  className="lw_btn"
                  onClick={() => setCurTimeOption(DEFAULT_TIME)}
                >
                  {t('noti_alert_addtime')}
                </button>
                <div className="lw_table_cover">
                  <table className="lw_table lw_table_head tb_auto_reply">
                    <thead>
                      <tr>
                        <th scope="col" className="days">
                          {t('noti_alert_week')}
                        </th>
                        <th scope="col" className="time">
                          {t('noti_alert_timerange')}
                        </th>
                        <th scope="col" className="manage">
                          {t('manage')}
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <div className="lw_table_scroll">
                    <table className="lw_table tb_auto_reply">
                      <tbody>
                        {config.timeSettings &&
                          config.timeSettings.map((timeOption) => {
                            return (
                              <tr key={timeOption.uuid}>
                                <td className="days">
                                  {createDaysText(timeOption.weekdays)}
                                </td>
                                <td className="time">
                                  {timeOption.startTime} ~ {timeOption.endTime}
                                </td>
                                <td className="manage">
                                  <div className="task">
                                    <button
                                      type="button"
                                      onClick={() => editTime(timeOption)}
                                    >
                                      {t('noti_edit')}
                                    </button>
                                    <span className="bar"></span>
                                    <button
                                      type="button"
                                      onClick={() => deleteTime(timeOption)}
                                    >
                                      {t('button_delete')}
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
            {ifShowHoliday && (
              <>
                <h4 className="title">
                  <span className="text"> {t('noti_alert_holidaynoti')}</span>
                  <Tooltip>{t('noti_alert_holidaynoti_tooltip')}</Tooltip>
                </h4>
                <div className="option_area">
                  <Toggle
                    value={config.enableHoliday}
                    label={'Toggle off notifications on holidays'}
                    onChange={() =>
                      handleEnableChange('enableHoliday', !config.enableHoliday)
                    }
                  />
                </div>
              </>
            )}
          </li>
        </ul>
      )}
      {alertMsg && (
        <Dialog.Alert
          title={alertMsg.title}
          description={alertMsg.description}
          onClose={() => setAlertMsg(null)}
        >
          <DialogButton.Action onSelect={(close) => close()}>
            {t('icon_confirm')}
          </DialogButton.Action>
        </Dialog.Alert>
      )}
      {curTimeOption && (
        <TimeSetting
          onCancle={() => setCurTimeOption(null)}
          onOk={(timeOption) => handleTimeChange(timeOption)}
          defaultValue={curTimeOption}
        />
      )}
    </PageContent>
  );
}
